var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeMcssImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 125,
    viewBox: "0 0 131 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.3887,
    y: 10.6729,
    width: 85.8692,
    height: 30.9925,
    rx: 2.73993,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5216,
    y: 11.16,
    width: 85.2033,
    height: 30.3266,
    rx: 2.40697,
    stroke: "black",
    strokeWidth: 0.665931,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7251,
    y: 16.2637,
    width: 18.9055,
    height: 18.9055,
    rx: 9.45277,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2285 30.7168H38.0142L41.5263 21.1519H42.7219L46.234 30.7168H45.0198L42.1615 22.6651H42.0868L39.2285 30.7168ZM39.6769 26.9805H44.5714V28.008H39.6769V26.9805Z",
    fill: "#35363A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 21.1348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 21.1348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 21.1348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 21.1348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 27.6348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 27.6348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 27.6348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 27.6348,
    width: 47.2811,
    height: 2.66373,
    rx: 1.33186,
    fill: "#E3DFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.3887,
    y: 43.5811,
    width: 85.8692,
    height: 30.9925,
    rx: 2.73993,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5216,
    y: 44.214,
    width: 85.2033,
    height: 30.3266,
    rx: 2.40697,
    stroke: "#35363A",
    strokeWidth: 0.665931,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7251,
    y: 49.1719,
    width: 18.9055,
    height: 18.9055,
    rx: 9.45277,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8362 63.625V54.0601H42.1802C42.8465 54.0601 43.396 54.1753 43.8288 54.4057C44.2616 54.633 44.5839 54.9397 44.7956 55.3258C45.0073 55.7088 45.1132 56.1338 45.1132 56.6008C45.1132 57.0118 45.04 57.3512 44.8937 57.6189C44.7504 57.8867 44.5605 58.0984 44.3239 58.2541C44.0904 58.4098 43.8366 58.525 43.5626 58.5997V58.6931C43.8553 58.7118 44.1495 58.8145 44.4453 59.0014C44.7411 59.1882 44.9886 59.4559 45.1879 59.8047C45.3872 60.1534 45.4868 60.5799 45.4868 61.0843C45.4868 61.5638 45.3778 61.9951 45.1599 62.378C44.9419 62.761 44.5979 63.0646 44.1277 63.2887C43.6576 63.5129 43.0458 63.625 42.2923 63.625H38.8362ZM39.9945 62.5975H42.2923C43.0489 62.5975 43.586 62.4512 43.9035 62.1585C44.2242 61.8627 44.3846 61.5047 44.3846 61.0843C44.3846 60.7605 44.3021 60.4616 44.1371 60.1876C43.972 59.9105 43.737 59.6895 43.4318 59.5244C43.1267 59.3563 42.7655 59.2722 42.3483 59.2722H39.9945V62.5975ZM39.9945 58.2634H42.1428C42.4915 58.2634 42.806 58.1949 43.0862 58.058C43.3696 57.921 43.5937 57.7279 43.7588 57.4788C43.9269 57.2297 44.011 56.9371 44.011 56.6008C44.011 56.1805 43.8646 55.824 43.5719 55.5313C43.2793 55.2355 42.8154 55.0876 42.1802 55.0876H39.9945V58.2634Z",
    fill: "#35363A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 54.1602,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 54.1602,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 54.1602,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 54.1602,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 60.542,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 60.542,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 60.542,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.1035,
    y: 60.542,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.9026,
    y: 76.4893,
    width: 85.8692,
    height: 30.9925,
    rx: 2.73993,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2356,
    y: 76.4222,
    width: 85.2033,
    height: 30.3266,
    rx: 2.40697,
    stroke: "#35363A",
    strokeWidth: 0.665931,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.239,
    y: 82.0801,
    width: 18.9055,
    height: 18.9055,
    rx: 9.45277,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5469 89.9574H45.3886C45.3201 89.6242 45.2002 89.3315 45.029 89.0793C44.8609 88.8271 44.6554 88.6154 44.4125 88.4442C44.1728 88.2698 43.9066 88.139 43.6139 88.0519C43.3212 87.9647 43.0161 87.9211 42.6985 87.9211C42.1194 87.9211 41.5947 88.0674 41.1246 88.3601C40.6576 88.6528 40.2855 89.084 40.0084 89.6538C39.7344 90.2236 39.5974 90.9226 39.5974 91.7508C39.5974 92.579 39.7344 93.278 40.0084 93.8478C40.2855 94.4175 40.6576 94.8488 41.1246 95.1414C41.5947 95.4341 42.1194 95.5805 42.6985 95.5805C43.0161 95.5805 43.3212 95.5369 43.6139 95.4497C43.9066 95.3625 44.1728 95.2333 44.4125 95.062C44.6554 94.8877 44.8609 94.6744 45.029 94.4222C45.2002 94.1669 45.3201 93.8742 45.3886 93.5442H46.5469C46.4597 94.033 46.3009 94.4705 46.0705 94.8566C45.8401 95.2426 45.5536 95.5711 45.2111 95.842C44.8687 96.1098 44.4841 96.3137 44.0576 96.4538C43.6341 96.5939 43.1811 96.664 42.6985 96.664C41.8827 96.664 41.1573 96.4647 40.5221 96.0662C39.887 95.6676 39.3872 95.101 39.0229 94.3662C38.6587 93.6314 38.4765 92.7596 38.4765 91.7508C38.4765 90.742 38.6587 89.8702 39.0229 89.1354C39.3872 88.4006 39.887 87.8339 40.5221 87.4354C41.1573 87.0368 41.8827 86.8376 42.6985 86.8376C43.1811 86.8376 43.6341 86.9076 44.0576 87.0477C44.4841 87.1878 44.8687 87.3933 45.2111 87.6642C45.5536 87.932 45.8401 88.2589 46.0705 88.645C46.3009 89.028 46.4597 89.4654 46.5469 89.9574Z",
    fill: "#35363A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 87.0684,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 87.0684,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 87.0684,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 87.0684,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 93.4502,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 93.4502,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 93.4502,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6174,
    y: 93.4502,
    width: 45.8286,
    height: 2.54603,
    rx: 1.27302,
    fill: "#9BBAC1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5874 58.6126L78.7519 18.2988L8.5874 58.6126Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.414 34.6101L118.882 31.4268L113.414 34.6101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87 40.8298L122.338 37.6465",
    stroke: "#E5E5E5",
    strokeWidth: 16.5442,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.363 78.6878C117.217 78.7769 117.837 79.5422 117.748 80.3956C117.659 81.249 116.894 81.8696 116.041 81.7805C115.187 81.6914 114.567 80.9261 114.656 80.0727C114.745 79.2193 115.51 78.5987 116.363 78.6878Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.770189
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6783 110.401C27.0817 110.548 28.1022 111.806 27.9557 113.21C27.8092 114.613 26.5507 115.633 25.1473 115.487C23.744 115.34 22.7235 114.082 22.87 112.679C23.0165 111.275 24.2749 110.255 25.6783 110.401Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4554 6.27429C62.8588 6.42081 63.8793 7.67923 63.7328 9.08262C63.5863 10.486 62.3278 11.5065 60.9244 11.36C59.5211 11.2134 58.5006 9.95502 58.6471 8.55163C58.7936 7.14824 60.052 6.12776 61.4554 6.27429Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.26652
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26176 38.877C2.90639 38.877 3.42977 39.4003 3.42977 40.045C3.42977 40.6896 2.90639 41.213 2.26176 41.213C1.61714 41.213 1.09375 40.6896 1.09375 40.045C1.09375 39.4003 1.61714 38.877 2.26176 38.877Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9793 115.045C93.6239 115.045 94.1473 115.568 94.1473 116.213C94.1473 116.858 93.6239 117.381 92.9793 117.381C92.3347 117.381 91.8113 116.858 91.8113 116.213C91.8113 115.568 92.3347 115.045 92.9793 115.045Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.925776
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.305 5.2207L107.639 0.726176",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.799 2.33789L109.294 3.67127",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99805 81.7539L8.16706 77.2139",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38818 78.9287L9.92824 80.0977",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M104.45 102.035L105.365 97.437",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.686 99.3037L107.284 100.218",
    stroke: "#4D5762",
    strokeWidth: 0.539404
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeMcssImg);
export default __webpack_public_path__ + "static/media/question_type_mcss_img.f6eddf6f58a094e6f8eb5f1c1b0b279d.svg";
export { ForwardRef as ReactComponent };